<section class="container-md">

  <app-lfsa-card  [innTemplate]="filtrosTemplate"
                  [titulo]="'Reporte de Extracto Bancario'" [efecto]="true"
                  [colapseName]="'filtrosTemplate'" [banderaColapse]='true'>
  </app-lfsa-card>

  <ng-template #filtrosTemplate>
          <form [formGroup]="formulario" class="form-group" novalidate>
            <div class="row">
              <div class="col-md-3">
                <app-lfsa-combo-box (change)="setBanco()" [claseLabel]="'letrasDanger'"
                                    [comboBox]="cmbEmpresa"
                                    [control]="formulario.get('idEmpresa')"
                                    [idOpcion]="'idEmpresa'"
                                    [opcion]="'dscaEmpresa'"
                                    [id]="'empresa'"
                                    [label]="'Empresa*'"
                                    formControlName="idEmpresa">
                </app-lfsa-combo-box>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-select-opt-isp  (update)="formulario.get('idBanco').setValue($event);setCuenta();"
                                            [claseLabel]="'letrasDanger'"
                                            [comboBox]="cmbBancos"
                                            [control]="formulario.get('idBanco')"
                                            [idOpcion]="'idBanco'"
                                            [opcion]="'descripcionBanco'"
                                            [id]="'idBanco'"
                                            [label]="'Id Banco*'"
                                            formControlName="idBanco">
                  </app-lfsa-select-opt-isp>
                </div>
              </div>
              <div class="col-md-3">
                <app-lfsa-input (input)="this.formulario.get('cuentaBancaria')"
                                [claseLabel]="'letrasDefault'"
                                [control]="this.formulario.get('cuentaBancaria')"
                                [id]="'cuentaBancaria'"
                                [isReadOnly]="'true'"
                                [label]="'No. Cuenta*'"
                                [type]="'string'"
                                formControlName="cuentaBancaria">
                </app-lfsa-input>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-input (input)="this.formulario.get('referencia')" [claseLabel]="'letrasDefault'"
                                  [control]="this.formulario.get('referencia')"
                                  [label]="'# Referencia'"
                                  [id]="'referencia'"
                                  [type]="'text'"
                                  formControlName="referencia">
                  </app-lfsa-input>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-combo-box [claseLabel]="'letrasDefault'"
                                      [comboBox]="cmbEstados"
                                      [control]="formulario.get('status')"
                                      [idOpcion]="'descripcion'"
                                      [opcion]="'display'"
                                      [id]="'status'"
                                      [label]="'Estado'"
                                      formControlName="status">
                  </app-lfsa-combo-box>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-combo-box [claseLabel]="'letrasDefault'"
                                      [comboBox]="cmbTipoMovimiento"
                                      [control]="formulario.get('tipo_movimiento')"
                                      [idOpcion]="'codigo'"
                                      [opcion]="'descripcion'"
                                      [id]="'tipo_movimiento'"
                                      [label]="'Tipo Movimiento*'"
                                      formControlName="tipo_movimiento">
                  </app-lfsa-combo-box>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-input [claseLabel]="'letrasDefault'" [control]="this.formulario.get('fechaExtracto_inicio') | formControl"
                                  [id]="'fechaExtracto_inicio'" [label]="'Fecha Extracto Desde'" [type]="'date'"
                                  formControlName="fechaExtracto_inicio">
                  </app-lfsa-input>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-input [claseLabel]="'letrasDefault'" [control]="this.formulario.get('fechaExtracto_fin') | formControl"
                                  [id]="'fechaExtracto_fin'" [label]="'Fecha Extracto Hasta'" [type]="'date'"
                                  formControlName="fechaExtracto_fin">
                  </app-lfsa-input>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-input [claseLabel]="'letrasDefault'" [control]="this.formulario.get('fechaContable_inicio') | formControl"
                                  [id]="'fechaContable_inicio'" [label]="'Fecha Contable Desde'" [type]="'date'"
                                  formControlName="fechaContable_inicio">
                  </app-lfsa-input>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-input [claseLabel]="'letrasDefault'" [control]="this.formulario.get('fechaContable_fin') | formControl"
                                  [id]="'fechaContable_fin'" [label]="'Fecha Contable Hasta'" [type]="'date'"
                                  formControlName="fechaContable_fin">
                  </app-lfsa-input>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-input (input)="this.formulario.get('montoDesde')" [claseLabel]="'letrasDefault'"
                                  [control]="this.formulario.get('montoDesde')"
                                  [label]="'Monto Hasta'"
                                  [id]="'montoDesde'"
                                  [type]="'number'"
                                  formControlName="montoDesde">
                  </app-lfsa-input>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <app-lfsa-input (input)="this.formulario.get('montoHasta')" [claseLabel]="'letrasDefault'"
                                  [control]="this.formulario.get('montoHasta')"
                                  [label]="'Monto Hasta'"
                                  [id]="'montoHasta'"
                                  [type]="'number'"
                                  formControlName="montoHasta">
                  </app-lfsa-input>
                </div>
              </div>
            </div>

            <div class="row mb-2 justify-content-center">
              <div class="col-md-12 d-flex justify-content-center">
                <button type="submit" class="btn btn-primary" [disabled]="!formulario.valid" (click)="findReporte()">
                  <i class="fas fa-search mr-2"></i>Buscar
                </button>
                <button type="button" class="btn btn-danger mx-2" (click)="resetForm()">
                  <i class="fas fa-eraser mr-2"></i>Limpiar
                </button>
              </div>
            </div>


          </form>
  </ng-template>

  <div class="container" style="padding-right: 0px;padding-left: 0px;">
    <div class="row">
      <div class="d-flex flex-row-reverse">
        <!--<button (click)="exportAsExcel()" class="btn btn-success">Exportar</button>-->
        <button (click)="exportAsExcel()"  class="btn btn-success" type="button" style="text-align: right;"><svg class="bi bi-filetype-xls" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z"></path>
        </svg>Descarga .XLS</button>
      </div>
      <div class="col-md-12 ">
        <app-lfsa-alerts [loading]="loadingGrid" [listaVacia]="listaVacia" [texto]="'No se encontraron datos en la lista de borradores.'" ></app-lfsa-alerts>
        <ag-grid-angular [floatingFilter]="true"
                         *ngIf="!listaVacia"
                         #agGrid [style]="moduloConciliacion.agGrid.style"
                         class="ag-theme-alpine"
                         [rowData]="rowData"
                         [columnDefs]="columnDefs"
                         [rowSelection]="rowSelection"
                         (gridReady)="onGridReady($event)"
                         [pagination]="true"
                         [suppressAutoSize]="true"
                         [alwaysShowHorizontalScroll]="true"
                         [paginationPageSize]="moduloConciliacion.agGrid.paginacion"
                         [enableCellTextSelection]="true">
        </ag-grid-angular>
      </div>
    </div>

  </div>

</section>
